import { Head, useForm } from "@inertiajs/react"
import AuthLayout from "@/components/auth/layout"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"

export default function ResetPassword({
  reset_password_token,
}: {
  reset_password_token: string
}) {
  const { data, setData, put, processing, errors, transform } = useForm({
    password: "",
    password_confirmation: "",
    reset_password_token,
  })

  transform((d) => ({ user: d }))

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    put("/password")
  }

  return (
    <>
      <Head title="Reset Password | QuiteRight" />
      <AuthLayout
        heading="Set a new password"
        subheading="Choose a strong password for your account."
      >
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <Label htmlFor="password">New password</Label>
            <Input
              id="password"
              type="password"
              value={data.password}
              onChange={(e) => setData("password", e.target.value)}
              placeholder="At least 6 characters"
              className="mt-1.5"
              autoComplete="new-password"
              required
            />
            {errors.password && (
              <p className="mt-1 text-xs text-red">{errors.password}</p>
            )}
          </div>

          <div>
            <Label htmlFor="password_confirmation">Confirm new password</Label>
            <Input
              id="password_confirmation"
              type="password"
              value={data.password_confirmation}
              onChange={(e) => setData("password_confirmation", e.target.value)}
              placeholder="Same as above"
              className="mt-1.5"
              autoComplete="new-password"
              required
            />
            {errors.password_confirmation && (
              <p className="mt-1 text-xs text-red">
                {errors.password_confirmation}
              </p>
            )}
          </div>

          <Button
            type="submit"
            disabled={processing}
            className="w-full bg-red py-5 text-sm font-semibold text-white hover:bg-red-deep"
          >
            {processing ? "Resetting..." : "Reset password"}
          </Button>
        </form>
      </AuthLayout>
    </>
  )
}
